import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { useAuthStore } from './auth.store';
/**
 * Renders children when the current user holds the required permission(s).
 * Super admins always pass. Use for conditionally showing/hiding UI elements.
 *
 * @example
 * <PermissionGate permission={PERMISSIONS.PLAYGROUND_ACCESS}>
 *   <NavLink to="/playground">AI Playground</NavLink>
 * </PermissionGate>
 */
export default function PermissionGate({ permission, requireAll = false, fallback = null, children }) {
    const user = useAuthStore((s) => s.user);
    if (!user)
        return _jsx(_Fragment, { children: fallback });
    if (user.isSuperAdmin)
        return _jsx(_Fragment, { children: children });
    const codes = Array.isArray(permission) ? permission : [permission];
    const allowed = requireAll
        ? codes.every((c) => user.permissions.includes(c))
        : codes.some((c) => user.permissions.includes(c));
    return allowed ? _jsx(_Fragment, { children: children }) : _jsx(_Fragment, { children: fallback });
}
